import React from "react"
import { graphql, Link } from "gatsby"
import Helmet from "react-helmet"
import config from "../../data/SiteConfig"
import Layout from "../layout/index"
import MorosoftBlogs from "../components/Our-blogs/index"

const BlogsPage = props => {
  return (
    <Layout location={props.location}>
      <Helmet title={`${config.siteTitle} | Blogs `} />
      <MorosoftBlogs />
    </Layout>
  )
}

export default BlogsPage
